import { Divider, Grid, makeStyles, Typography } from '@material-ui/core'
import { Box } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import DataClient from '../../../../../../Service/general_data_service';

const useStyles = makeStyles((theme) => ({
    toggleBtn: {
        // fontSize: "18px",
        // fontFamily: "Open Sans",
        backgroundColor: "#fff",
        color: "#4089FC",
        border: "1px solid #00808080",
        padding: "5px 10px",
        borderRadius: "5px 0px 0px 5px",
        cursor: 'pointer',
        "& + $toggleBtn": {
            borderRadius: "0px 5px 5px 0px"
        },

        "&.active": {
            backgroundColor: "#4089FC",
            color: "#fff"
        }
    },
    large: {
        width: theme.spacing(13),
        height: theme.spacing(13),
    },
}));

function CommercialsNBilling(props) {
    const classes = useStyles();
    const globaluserData = useSelector((state) => state.commonReducer);
    const userRole = globaluserData.role;
    // const userRole=sessionStorage.getItem("role");
    const [activeBtnText, setActiveBtnText] = useState( userRole!=="partner"?"Client":"Supplier");
    const [pageData, setPageData] = useState({});
    const [pageRenderFlag, setPageRenderFlag] = useState(false);

    // className={"toggleBtn " + activeBtnText == "Client" ? "active" : ""} 
    useEffect(() => {
        getData()
    }, [activeBtnText])

    //Access Permission
    const accessArray = useSelector((state) => state.commonReducer)?.accessPermission?.assignmentDetail?.assignmentOverview?.commercialBilling

    const getData = (params) => {
        DataClient.getData('assignment_details/fetch_commercial_billing?assignment_id=' + props.location.state.currentAssignment.id + '&user_type=' + activeBtnText.toLowerCase())
            .then((res) => {
                setPageData({ ...pageData, ...res.data })
                setPageRenderFlag(true)
            })
            .catch((res) => {

            })
    }

    const primaryData = pageData?.price_summary?.filter((item) => item?.category === "primary")
    const addOnData = pageData?.price_summary?.filter((item) => item?.category === "add_ons")

    const gridSize = accessArray?.marginPer ? 2 : 3;
    const totalGridSize = accessArray?.marginPer ? 6 : 9;

    return <Box my={3}>
        {userRole==="admin"&& accessArray && accessArray.tabs?.length > 1 ? <Grid container direction="row">
            <Grid item xs="12">
                <Box mb={3}>
                    {userRole !== "partner" && ( accessArray?.tabs?.includes('Client') ? <Box component="span" className={classes.toggleBtn} style={{ backgroundColor: activeBtnText === "Client" ? "#008080" : "#fff", color: activeBtnText == "Client" ? "#fff" : "#00808080" }} onClick={() => setActiveBtnText('Client')}>Client</Box> : null)}
                    { (accessArray?.tabs?.includes('Supplier') ? <Box component="span" className={classes.toggleBtn} style={{ backgroundColor: activeBtnText === "Supplier" ? "#008080" : "#fff", color: activeBtnText == "Supplier" ? "#fff" : "#00808080" }} onClick={() => setActiveBtnText('Supplier')}>Supplier</Box> : null)}
                </Box>
            </Grid>
        </Grid> : null
        }
        {
            accessArray &&
            pageRenderFlag && (activeBtnText === "Client" ?

                <Grid container direction="row">
                    <Grid item xs="12">
                        <Typography variant="subtitle1">
                            <Box mb={3} fontWeight="fontWeightBold">Price summary</Box>
                        </Typography>
                    </Grid>
                    <Grid item xs="12">
                        <Box bgcolor="#00808033" p={2} borderRadius={10}>
                            <Grid container direction="row">
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Label</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Rate card type</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Program hours</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Price</Box>
                                    </Typography>
                                </Grid>
                                {accessArray?.marginPer && <>
                                    <Grid item xs={gridSize}>
                                        <Typography variant="h2">
                                            <Box fontWeight="fontWeightBold">Margin % (Acuity)</Box>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={gridSize}>
                                        <Typography variant="h2">
                                            <Box fontWeight="fontWeightBold">Margin % (Coach)</Box>
                                        </Typography>
                                    </Grid>
                                </>}
                            </Grid>
                        </Box>
                        <Box p={2}>
                            <Grid container direction="row" spacing={1}>
                                {
                                    primaryData?.map((item) => <>
                                        <Grid item xs={gridSize}>
                                            <Typography variant="h2">
                                                <Box  >{item?.label || "-"}</Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={gridSize}>
                                            <Typography variant="h2">
                                                <Box  >{pageData?.rate_card_type || "-"}</Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={gridSize}>
                                            <Typography variant="h2">
                                                <Box  >{item?.num_of_hours || '-'}</Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={gridSize}>
                                            <Typography variant="h2">
                                                <Box  > {item.price || "-"}</Box>
                                            </Typography>
                                        </Grid>
                                        {accessArray?.marginPer && <>
                                            <Grid item xs={gridSize}>
                                                <Typography variant="h2">
                                                    <Box  >{item?.acuity_margin_percent || "-"}</Box>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={gridSize}>
                                                <Typography variant="h2">
                                                    <Box  >{item?.coach_margin_percent || "-"}</Box>
                                                </Typography>
                                            </Grid>
                                        </>}
                                    </>
                                    )
                                }
                            </Grid>
                        </Box>
                        <Box mb={3} p={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={totalGridSize}>
                                    <Typography variant="h2">
                                        <Box pr={3} textAlign="right" fontWeight="fontWeightBold">Coaching program price</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">
                                            {/* {pageData.price_summary[0]?.currency} */}
                                            {pageData.price_summary[0]?.price || 0}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs="12">
                        <Box bgcolor="#00808033" p={2} borderRadius={10}>
                            <Grid container direction="row">
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Add-on</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Price</Box>
                                    </Typography>
                                </Grid>
                                {accessArray?.marginPer && <>
                                    <Grid item xs={gridSize}>
                                        <Typography variant="h2">
                                            <Box fontWeight="fontWeightBold">Margin % (Acuity)</Box>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={gridSize}>
                                        <Typography variant="h2">
                                            <Box fontWeight="fontWeightBold">Margin % (Coach)</Box>
                                        </Typography>
                                    </Grid>
                                </>}
                            </Grid>
                        </Box>
                        <Box p={2}>
                            {addOnData?.filter(el=>el.label!==null)?.map((item) => (<Grid container direction="row" spacing={1}>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box  >{item.label || "-"}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box  ></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box  ></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box  > {item.price || 0}</Box>
                                    </Typography>
                                </Grid>
                                {accessArray?.marginPer && <>
                                    <Grid item xs={gridSize}>
                                        <Typography variant="h2">
                                            <Box  >{item.acuity_margin_percent || "-"}</Box>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={gridSize}>
                                        <Typography variant="h2">
                                            <Box  >{item.coach_margin_percent || "-"}</Box>
                                        </Typography>
                                    </Grid>
                                </>}
                            </Grid>))}
                        </Box>
                        <Box p={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={totalGridSize}>
                                    <Typography variant="h2">
                                        <Box pr={3} textAlign="right" fontWeight="fontWeightBold">Coaching program price</Box>
                                    </Typography>
                                </Grid>

                                <Grid item xs={gridSize}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">
                                            {/* {pageData?.price_summary[0]?.currency}   */}
                                            {pageData.specified_element_price}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs="12">
                        <Box p={2} style={{ backgroundColor: "#00808080", color: "#fff" }} borderRadius={10}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={totalGridSize}>
                                    <Typography variant="h2" style={{ color: "#fff" }}>
                                        <Box textAlign="right" fontWeight="fontWeightBold">Total program price</Box>
                                    </Typography>
                                </Grid>

                                <Grid item xs={gridSize}>
                                    <Typography variant="h2" style={{ color: "#fff" }}>
                                        <Box textAlign="left" fontWeight="fontWeightBold">
                                            {/* {pageData?.price_summary[0]?.currency}  */}
                                            {pageData.total_pgm_price}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Typography variant="subtitle1">
                                <Box fontWeight="fontWeightBold">Client invoicing basics</Box>
                            </Typography>
                        </Box>
                        {
                            pageData.invoicing_basic.map((option) => {
                                return <Box mb={2}>
                                    <Typography variant="h2">
                                        <Box  >{option}</Box>
                                    </Typography>
                                </Box>
                            })
                        }
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="6">
                                    <Typography variant="subtitle1" >
                                        <Box mb={2} fontWeight="fontWeightBold">Client invoicing schedule</Box>
                                    </Typography>
                                    <Typography variant="h2" >
                                        <Box  >Number of tranches - {pageData.primary_invoicing_schedule.num_of_tranche}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="6">
                                    <Typography variant="subtitle1" >
                                        <Box mb={2} fontWeight="fontWeightBold">Client billing schedule</Box>
                                    </Typography>
                                    {
                                        pageData.primary_invoicing_schedule.billing_schedules.map((option) => {
                                            return <Typography variant="h2" >
                                                <Box>{option.percentage} {option?.pgm_price_type} - {option.installment_type}</Box>
                                            </Typography>
                                        })
                                    }


                                </Grid>
                            </Grid>
                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="6">
                                    <Typography variant="subtitle1" >
                                        <Box mb={1} fontWeight="fontWeightBold">Client invoicing options</Box>
                                    </Typography>
                                    {
                                        pageData.invoicing_option.map((option) => {
                                            return <Box mb={2}>
                                                <Typography variant="h2">
                                                    <Box  >{option}</Box>
                                                </Typography>
                                            </Box>
                                        })
                                    }
                                </Grid>
                            </Grid>

                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Typography variant="subtitle1" >
                                <Box mb={2} fontWeight="fontWeightBold">Client invoicing details</Box>
                            </Typography>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "rgb(7,121,131)" }} >
                                        <Box mb={1}>Name</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "rgb(7,121,131)" }} >
                                        <Box mb={1}>Invoice address</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "rgb(7,121,131)" }} >
                                        <Box mb={1}>Email</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "rgb(7,121,131)" }} >
                                        <Box mb={1}>Invoice narrative</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.name}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.invoice_address}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.email[0]}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.invoice_narrative}</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Typography variant="subtitle1" >
                                <Box mb={2} fontWeight="fontWeightBold">Client expense policy</Box>
                            </Typography>
                            {
                                pageData.expense_policy?.map((item) => {
                                    return <Typography variant="h2" >
                                        <Box>- {item}</Box>
                                    </Typography>
                                })
                            }
                        </Box>
                        <Divider />
                    </Grid>
                </Grid>
                : <Grid container direction="row">
                    <Grid item xs="12">
                        <Typography variant="subtitle1">
                            <Box mb={3} fontWeight="fontWeightBold">Price summary</Box>
                        </Typography>
                    </Grid>
                    <Grid item xs="12">
                        <Box bgcolor="#00808033" p={2} borderRadius={10}>
                            <Grid container direction="row">
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Label</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Rate card type</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Program hours</Box>
                                    </Typography>
                                </Grid>

                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Price</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box p={2}>
                            <Grid container direction="row" spacing={1}>
                                {
                                    primaryData?.map((item) => <>
                                        <Grid item xs="2">
                                            <Typography variant="h2">
                                                <Box  >{item.label || "-"}</Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="2">
                                            <Typography variant="h2">
                                                <Box  >{pageData.rate_card_type || "-"}</Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="2">
                                            <Typography variant="h2">
                                                <Box  >{item.num_of_hours || '-'}</Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="2">
                                            <Typography variant="h2">
                                                <Box  ></Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="2">
                                            <Typography variant="h2">
                                                <Box  ></Box>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="2">
                                            <Typography variant="h2">
                                                <Box  > {item.price || "-"}</Box>
                                            </Typography>
                                        </Grid>

                                    </>
                                    )
                                }
                            </Grid>
                        </Box>
                        <Box mb={3} p={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={10}>
                                    <Typography variant="subtitle1">
                                        <Box textAlign="right" fontWeight="fontWeightBold">Coaching program price</Box>
                                    </Typography>
                                </Grid>

                                <Grid item xs={2} style={{ display: "grid", alignItems: "center" }}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"> {pageData.price_summary[0]?.price || 0}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs="12">
                        <Box bgcolor="#00808033" p={2} borderRadius={10}>
                            <Grid container direction="row">
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Add-on</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold"></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">Price</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                        <Box p={2}>
                            {addOnData?.map((item) => (<Grid container direction="row" spacing={1}>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box  >{item.label || "-"}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box  ></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box  ></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box  ></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box  ></Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="2">
                                    <Typography variant="h2">
                                        <Box  > {item.price || "-"}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>))}
                        </Box>
                        <Box p={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={10}>
                                    <Typography variant="subtitle1">
                                        <Box textAlign="right" fontWeight="fontWeightBold">Coaching program price</Box>
                                    </Typography>
                                </Grid>

                                <Grid item xs={2} style={{ display: "grid", alignItems: "center" }}>
                                    <Typography variant="h2">
                                        <Box fontWeight="fontWeightBold">{pageData.specified_element_price}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs="12">
                        <Box p={2} style={{ backgroundColor: "#00808080", color: "#fff" }} borderRadius={10}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={10}>
                                    <Typography variant="subtitle1" style={{ color: "#fff" }}>
                                        <Box textAlign="right" fontWeight="fontWeightBold">Total program price</Box>
                                    </Typography>
                                </Grid>

                                <Grid item xs={2} style={{ display: "grid", alignItems: "center" }}>
                                    <Typography variant="h2" style={{ color: "#fff" }}>
                                        <Box textAlign="left" fontWeight="fontWeightBold">
                                            {/* {pageData?.price_summary[0]?.currency}  */}
                                            {pageData.total_pgm_price}</Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Typography variant="subtitle1">
                                <Box fontWeight="fontWeightBold">Supplier invoicing basics</Box>
                            </Typography>
                        </Box>
                        {
                            pageData.invoicing_basic.map((option) => {
                                return <Box mb={2}>
                                    <Typography variant="h2">
                                        <Box  >{option}</Box>
                                    </Typography>
                                </Box>
                            })
                        }
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="6">
                                    <Typography variant="subtitle1" >
                                        <Box mb={2} fontWeight="fontWeightBold">Supplier invoicing schedule</Box>
                                    </Typography>
                                    <Typography variant="subtitle1" >
                                        <Box  >Number of tranches - {pageData.primary_invoicing_schedule.num_of_tranche}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="6">
                                    <Typography variant="subtitle1" >
                                        <Box mb={2} fontWeight="fontWeightBold">Supplier billing schedule</Box>
                                    </Typography>
                                    {
                                        pageData.primary_invoicing_schedule.billing_schedules.map((option) => {
                                            return <Typography variant="h2" >
                                                <Box>{option.percentage} {option?.pgm_price_type} - {option.installment_type}</Box>
                                            </Typography>
                                        })
                                    }


                                </Grid>
                            </Grid>
                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="6">
                                    <Typography variant="subtitle1" >
                                        <Box mb={1} fontWeight="fontWeightBold">Supplier invoicing options</Box>
                                    </Typography>
                                    {
                                        pageData.invoicing_option.map((option) => {
                                            return <Box mb={2}>
                                                <Typography variant="h2">
                                                    <Box  >{option}</Box>
                                                </Typography>
                                            </Box>
                                        })
                                    }
                                </Grid>
                            </Grid>

                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Typography variant="subtitle1" >
                                <Box mb={2} fontWeight="fontWeightBold">Supplier invoicing details</Box>
                            </Typography>

                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "#008080" }} >
                                        <Box mb={1}>Name</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "#008080" }} >
                                        <Box mb={1}>Invoice address</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "#008080" }} >
                                        <Box mb={1}>Email</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2" style={{ color: "#008080" }} >
                                        <Box mb={1}>Invoice narrative</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={1}>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.name}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.invoice_address}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.email[0]}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs="3">
                                    <Typography variant="h2">
                                        <Box mb={1}>{pageData.invoicing_detail.invoice_narrative}</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs="12">
                        <Box my={2}>
                            <Typography variant="subtitle1" >
                                <Box mb={2} fontWeight="fontWeightBold">Supplier expense policy</Box>
                            </Typography>
                            {
                                pageData.expense_policy?.map((item) => {
                                    return <Typography variant="h2" >
                                        <Box>- {item}</Box>
                                    </Typography>
                                })
                            }
                        </Box>
                        <Divider />
                    </Grid>
                </Grid>
            )
        }
    </Box >
}

export default CommercialsNBilling

